import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69edd68263911b00147761ef_1781245195912_da93ba62/bloodhound/src/app/diagnostic/page.tsx");
